/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Personal_BodyInputs */

const cs_integrations_personal_body = /** @type {(inputs: Integrations_Personal_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každý makléř na profilu propojí Google, Microsoft a osobní Facebook stránku. Firemní Meta pro kancelář nastaví admin v Integracích. Tokeny zůstanou na jeho profilu.`)
};

const en_integrations_personal_body = /** @type {(inputs: Integrations_Personal_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each broker connects Google, Microsoft, and a personal Meta Page on their profile. Company Meta for the office is set up on Integrations by an admin. Tokens stay on that person’s profile.`)
};

/**
* | output |
* | --- |
* | "Each broker connects Google, Microsoft, and a personal Meta Page on their profile. Company Meta for the office is set up on Integrations by an admin. Tokens ..." |
*
* @param {Integrations_Personal_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_personal_body = /** @type {((inputs?: Integrations_Personal_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Personal_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_personal_body(inputs)
	return cs_integrations_personal_body(inputs)
});